import { NgIf, NgClass, AsyncPipe } from '@angular/common'
import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { MatLabel } from '@angular/material/form-field'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { AuthService, GlobalMessageType, TranslatePipe } from '@spartacus/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { EbGlobalMessageService } from 'src/app/features/global-message/services/eb-global-message.service'
import { EbUserAdapter } from 'src/app/features/user/services/connectors/eb-user-adapter'
import { EbUnitSelectorService } from './eb-unit-selector.service'

@Component({
  selector: 'eb-unit-selector',
  templateUrl: './eb-unit-selector.component.html',
  styleUrl: './eb-unit-selector.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, MatLabel, NgClass, MatSlideToggle, AsyncPipe, TranslatePipe]
})
export class EbUnitSelectorComponent implements OnInit {
  checked: boolean
  unitMap = new Map([
    ['INH', false],
    ['MMT', true]
  ])
  isLoggedIn$: Observable<boolean>
  isLoading$ = new BehaviorSubject(true)

  constructor(
    protected ebUserAdapter: EbUserAdapter,
    protected authService: AuthService,
    protected globalMessageService: EbGlobalMessageService,
    protected ebUnitSelectorService: EbUnitSelectorService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.authService.isUserLoggedIn()
    this.isLoggedIn$.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.getUnit()
      }
    })
  }

  changed(event) {
    const unit = this.getKeyByValue(event.checked)
    this.ebUserAdapter
      .setCustomerMeasuringUnit(this.getKeyByValue(event.checked))
      .subscribe(success => {
        if (!success) {
          this.globalMessageService.add(
            {
              key: 'unitSelector.error'
            },
            GlobalMessageType.MSG_TYPE_ERROR
          )
        } else {
          this.ebUnitSelectorService.setUnitValue(unit)
          this.ebUnitSelectorService.unitChanged()
        }
      })
  }

  getKeyByValue(checked: boolean) {
    let result: string
    this.unitMap.forEach((value, key) => {
      result = value === checked ? key : result
    })
    return result
  }

  getUnit() {
    this.ebUserAdapter.getCustomerMeasuringUnit().subscribe(unit => {
      this.ebUnitSelectorService.setUnitValue(unit.code)
      this.checked = this.unitMap.get(unit.code)
      this.isLoading$.next(false)
    })
  }
}
